import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './landing.html',
  styleUrl: './landing.css',
})
export class Landing implements AfterViewInit{

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  productos = [
    {
      slug: 'hoodie-moanani',
      nombre: 'Hoodie',
      top: '70%',
      left: '40%'
    },
    {
      slug: 'chicano-tank-tops-hombre',
      nombre: 'Chicano Tank Top',
      top: '46%',
      left: '56%'
    }
  ];

  ngAfterViewInit() {
    this.centerImageOnMobile();
  }

  centerImageOnMobile() {
    if (window.innerWidth <= 1180) {
      const container = this.scrollContainer.nativeElement;
      const centerPosition = (container.scrollWidth - container.clientWidth) / 2;
      container.scrollTo({
        left: centerPosition,
        behavior: 'smooth'
      });
    }
  }

  constructor(private router: Router) {}

  irAlDetalle(slug: string) {
    console.log('Navegando al producto:', slug);
    this.router.navigate(['/product', slug]);
  }
}
